import {
  Dialog,
  DialogTitle,
  Box,
  Typography,
  DialogContent,
  DialogContentText,
  Alert,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  DialogActions,
  Button,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import InfoIcon from "@mui/icons-material/Info";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import { LoadingButton } from "@mui/lab";

const NotaryCancelModal = ({
  handleNotaryCancelConfirm,
  notaryCancelModalOpen,
  handleNotaryCancelClose,
  notaryCancelLoading,
  responseMessage,
  isError,
}) => {
  // Notary cancellation confirmation modal state

  return (
    <Dialog
      open={notaryCancelModalOpen}
      onClose={notaryCancelLoading ? () => {} : handleNotaryCancelClose}
      maxWidth="md"
      fullWidth
      slotProps={{
        paper: {
          sx: {
            borderRadius: 2,
            boxShadow: 3,
          },
        },
      }}
    >
      <DialogTitle sx={{ textAlign: "center", pb: 1 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <WarningIcon sx={{ color: "error.main", fontSize: 32 }} />
          <Typography variant="h5" fontWeight="bold" color="error.main">
            Cancel Notary Subscription
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ px: 3, py: 2 }}>
        <DialogContentText
          sx={{ mb: 3, textAlign: "center", fontSize: "1.1rem" }}
        >
          Are you sure you want to cancel your notary subscription? This action
          cannot be undone.
        </DialogContentText>

        <Alert severity="warning" sx={{ mb: 3 }}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Important Information:
          </Typography>
          <List dense>
            <ListItem sx={{ px: 0 }}>
              <ListItemIcon>
                <MoneyOffIcon color="error" />
              </ListItemIcon>
              <ListItemText
                primary="No Refunds Available"
                secondary="If you cancel your notary subscription now, we cannot offer any refunds for the cancellation."
              />
            </ListItem>
            <ListItem sx={{ px: 0 }}>
              <ListItemIcon>
                <AccessTimeIcon color="warning" />
              </ListItemIcon>
              <ListItemText
                primary="Pending Notarizations"
                secondary="If you have any pending notarizations in progress, the cancellation will take place only when all progress has been completed."
              />
            </ListItem>
            <ListItem sx={{ px: 0 }}>
              <ListItemIcon>
                <InfoIcon color="info" />
              </ListItemIcon>
              <ListItemText
                primary="24-Hour Grace Period"
                secondary="If there are no pending notarizations, the cancellation will be pending for one day. During this period, you can cancel the cancellation if you change your mind."
              />
            </ListItem>
          </List>
        </Alert>

        <Box
          sx={{
            backgroundColor: "#f5f5f5",
            p: 2,
            borderRadius: 1,
            border: "1px solid #ddd",
          }}
        >
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontStyle: "italic" }}
          >
            By proceeding with the cancellation, you acknowledge that you have
            read and understood the terms above, including the no-refund policy
            and the cancellation timeline.
          </Typography>
        </Box>
        <Box>
          <Typography align="center" color={isError ? "error" : "success"}>
            {responseMessage}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, gap: 2 }}>
        <Button
          onClick={handleNotaryCancelClose}
          variant="outlined"
          size="large"
          sx={{ minWidth: 120 }}
          disabled={notaryCancelLoading}
        >
          Keep Subscription
        </Button>
        <LoadingButton
          loading={notaryCancelLoading}
          onClick={handleNotaryCancelConfirm}
          variant="contained"
          color="error"
          size="large"
          sx={{ minWidth: 120 }}
        >
          Cancel Subscription
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default NotaryCancelModal;
